import { FleetActivationsScreen } from "@src/features/patriot-tools";

export default FleetActivationsScreen;
